<template>
  <div class="newcomerMore" v-infinite-scroll="getNewcomers" infinite-scroll-disabled="busy" infinite-scroll-distance="150" infinite-scroll-root>
    <CustomizeHeader :home="false" :goBack="true"  title="新人榜"></CustomizeHeader>
    <v-row class="py-1 ma-0">
      <v-col
        class="d-flex justify-center align-center" 
        style="padding: 6px"
        cols="4" 
        sm="2" 
        md="2" 
        lg="1" 
        xl="1" 
        v-for="seller in newcomers"
      >
        <div class="seller" @click="$router.push(`/seller/${seller.id}`)">
        <v-avatar size="100%" min-height="100">
          <v-img aspect-ratio="1" :src="$HOST_URL + seller.usericon"/>
        </v-avatar>
        <div class="text-ellipsis text-center mt-1" :title="seller.nickname">{{ seller.nickname }}</div>
      </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import CustomizeHeader from '@/components/CustomizeHeader'
export default {
  components: { CustomizeHeader },
  data() {
    return {
      page: 1,
      busy: false,
      newcomers: [],
    }
  },
  created() {

  },
  methods: {
    getNewcomers() {
      this.busy = true
      this.axios(`/product/rank/newcomer?type=month&page=${this.page}&size=50`).then(response => {
        this.newcomers = this.newcomers.concat(response.data.data)
        if(this.page != response.data.last_page) {
          this.page += 1
          this.busy = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.newcomerMore {
  .seller {
    @extend .pointer;
    padding: 4px;
    overflow: auto;
    font-size: 14px;
    width: 100%;
    &:hover {
      transform: scale(1.015);
    }
  }
}
</style>